import { motion, useScroll } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      data-testid="scroll-progress"
      className="fixed left-0 right-0 top-0 z-[70] h-[2px] origin-left bg-brand"
      style={{ scaleX: scrollYProgress }}
      aria-hidden="true"
    />
  );
}
